/*
 * @Author: your name
 * @Date: 2019-05-29 22:36:24
 * @LastEditTime: 2020-07-17 10:44:13
 * @LastEditors: OBKoro1
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/config/api.js
 */
const api = {
  // 'Test' : '/test/index.php',
  // 'upload': '/Index/Index/upload', // 上传图片
  // 'sendSms': '/Index/Index/sendSms', // 发送短信验证码
  // 'qiniuToken': '/Index/Index/qiniuToken', //获取七牛云上传图片token
  // 'answer': '/Index/Index/answer', // 调研回答
  // 'getUserInfo': '/Index/Index/getUserInfo', //获取用户信息
  // 'getUserAnswer': '/Index/Index/getUserAnswer', //获取用户信息
  // 'getWechatOpenid': '/Index/Index/getWechatOpenid', //获取微信openid
  // 'applyPly': '/Index/Index/applyPly', // 申请支付
  // 'register': '/Index/Index/register', // 注册
  // 'sendSecondNotice': '/Index/Index/sendSecondNotice', //发送二期未开始的通知

  'browseTime': '/Index/Index/browseTime', // 增加浏览时间
  'registerUser': '/Index/Index/registerUser', // 注册用户
  'userLogin': '/Index/Index/userLogin', // 用户登录
  'getVideoListById': '/Index/Index/getVideoListById', // 视频列表
  'getVideoInfoById': '/Index/Index/getVideoInfoById', // 视频详细
  'updateVideoSee': '/Index/Index/updateVideoSee', // 视频观看时间
  'getWechatOpenid': '/Index/Index/getWechatOpenid', //获取微信openid
  'answer': '/Index/Index/answer', // 调研回答
  'getAnswer2': '/Index/Index/getAnswer2', // 获取用户最想做的事情
  'getUserInfo': '/Index/Index/getUserInfo', //获取用户信息
  'editUserInfo': '/Index/Index/editUserInfo', //编辑用户信息
  'getCommentList': '/Index/Index/getCommentList', //评论列表
  'addComment': '/Index/Index/addComment', //增加评论
  'getWechatJssdk': '/Index/Index/getWechatJssdk', //微信jssdk
  'getWechatUserInfo': '/Index/Index/getWechatUserInfo', //微信jssdk
  'addMeetingUser': '/Index/Index/addMeetingUser', //增加会议报名
  'addMeetingUser2': '/Index/Index/addMeetingUser2', //增加会议报名2
  
  'addResearchOther': '/Index/Index/addResearchOther', //增加其他调研
  'getQrcode':  '/Index/Index/getQrcode', // 会议报名二维码
  'getQrcode2':  '/Index/Index/getQrcode2', // 会议报名二维码
  'getCarouselList':  '/Index/Index/getCarouselList', // 获取轮播图
  'getMeetingSetList': '/Index/Index/getMeetingSetList' // 获取会议设置

}


export default api



// WEBPACK FOOTER //
// ./src/config/api.js